<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
        <a-icon type="calendar"/>
        Control pago
       </span>
        <a-card>
          <g-master name="payroll_control"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="parentData"
                    modalWidth="90%"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha Ctrl. Pago')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['date_control_to', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tipo')">
                    <a-input v-decorator="['pay_type', { rules:
                    [{
                      required: $getConfigValue('CTRL_PAGO_CAMPO_TIPO_REQUERIDO', null) === 'SI',
                      message: 'Valor requerido'
                    }]}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    props: ['empleadoseleccionado'],
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'payroll_control',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Fecha Ctrl. Pago', dataIndex: 'date_control_to_desc', sorter: true},
              {title: 'Tipo', dataIndex: 'pay_type', sorter: true},
              {title: 'Proceso', dataIndex: 'prc', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'date_control_to'},
            {name: 'pay_type'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/PayrollControl.vue